import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 12px 20px;
  background: var(--filter-bar-bg);
  align-items: center;
  height: 84px;
  flex-wrap: wrap;
  row-gap: 10px;
  .label-wrapper {
    font-size: 16px;
    font-weight: 900;
    color: var(--theme-text);
    font-family: "Lato";
    font-style: normal;
  }
`;
export const UsageContainer = styled.div`
  padding: 20px 30px 0;
  background-color: #fafcff;
  overflow: auto;
  max-height: calc(100vh - 58px);
  @media (max-width: 850px) {
    padding: 13px;
    padding-bottom: 68px;
  }
`;

export const ChartRow = styled.div`
  /* display: flex; */
  /* align-items: stretch; */
  display: grid;
  grid-template-columns: 1fr 500px;
  gap: 6px;
  padding: 10px;
  margin-bottom: 15px;
  @media (max-width: 850px) {
    grid-template-columns: 1fr;
    .MuiDataGrid-main {
      > div {
        z-index: 1;
      }
    }
  }
  > div {
    /* width: 40%; */
    background-color: #fff;
    box-shadow: 2px 4px 5px 2px rgba(0, 0, 0, 0.02);
    padding: 0 20px;
    min-height: 500px;
    .MuiDataGrid-columnHeaders {
      width: 100%;
    }
    .MuiDataGrid-columnSeparator {
      display: none;
    }
    .MuiDataGrid-columnHeadersInner {
      width: 100%;
      > div {
        width: 100%;
        > div {
          width: 40% !important;
          background: linear-gradient(180deg, #c2ac71 0%, #f4f4d4 100%);
          border: 1px solid #c2ac71;
          min-width: auto !important;
          max-width: 100% !important;
          :last-child {
            width: 60% !important;
            min-width: auto !important;
            max-width: 100% !important;
          }
          .MuiDataGrid-columnHeaderTitleContainer {
            width: 100%;
            justify-content: center;
            .MuiDataGrid-columnHeaderTitleContainerContent {
              font-weight: 400;
              font-size: 13px;
              line-height: 150.5%;
              text-transform: uppercase;
            }
          }
        }
      }
    }
    .MuiDataGrid-virtualScrollerRenderZone {
      width: 100%;

      .MuiDataGrid-row {
        width: 100%;
        > div {
          width: 40% !important;
          justify-content: center;
          :nth-child(2) {
            width: 60% !important;
          }
        }
      }
    }
    :nth-child(2) {
      padding: 86px 7px 50px;
      position: relative;
    }
    .heading {
      padding: 15px 14px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;

      > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
          font-size: 13px;
          line-height: 150.5%;
        }
      }
      .last-section {
        justify-content: flex-end;
        font-size: 13px;
        line-height: 150.5%;
      }
    }
    .action-btn {
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      button,
      a {
        background: #ffffff;
        border: 1px solid #636f7c;
        border-radius: 30px;
        height: 30px;
        font-size: 13px;
        line-height: 150.5%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
      }
      a {
        text-decoration: none;
        color: #000;
      }
    }
    /* :first-child {
      width: 60%;
    } */
  }
`;

export const NoData = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Wrapper = styled.div``;

export const SortingHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  background: #6b5c4b;
  color: #fff;
  flex-wrap: wrap;
  gap: 10px 0;
  .date-range-wrapper {
    display: flex;
    align-items: center;
  }
  &.fleet-usage {
    background: var(--inner-section-bg);
  }
  .toggle-btn-wrapper {
    border: 1px solid #bc9b6a;
    border-radius: 6px;
    display: flex;
    align-items: center;
    button {
      width: 62px;
      font-size: 13px;
      line-height: 150.5%;
      border: none;
      border-radius: 6px;
    }
  }
  .label-wrapper {
    display: flex;
    align-items: center;
    border-right: 1px solid #cdcfd0;
    padding: 0 15px;
    gap: 15px;
    input {
      /* border: 1px solid #cdcfd0; */
      /* border-radius: 6px; */
      min-height: 30px;
      padding: 0 10px;
    }
    .MuiInputBase-root {
      background: #ffffff;
      max-width: 200px;
    }
    label {
      font-size: 13px;
      line-height: 16px;
      white-space: nowrap;
    }
  }
  .btn-header-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 15px;
    flex-wrap: wrap;
    border-right: 1px solid #cdcfd0;
    button {
      font-size: 13px;
      border-radius: 6px;
      border-color: rgb(188, 155, 106);
      color: #fff;
    }
  }
  @media (max-width: 850px) {
    padding: 12px 13px;
    flex-direction: column-reverse;
    .label-wrapper {
      border: none;
      padding: 0;
      gap: 15px;
      label,
      input {
        font-size: 12px;
        font-weight: 500;
      }
    }
    .date-range-wrapper {
      gap: 15px;
    }
    .btn-header-wrapper {
      border: none;
      padding: 0;
      gap: 9px;
      button {
        font-size: 12px;
      }
    }
  }
`;

// export const Header = styled.div`
//   h2 {
//     font-weight: 700;
//     font-size: 16px;
//     line-height: 150.5%;
//     padding: 17px 0 9px;
//   }
//   border-bottom: 1px solid #d1d0cb;
//   position: absolute;
//   top: 0;
//   right: 0;
//   left: 0;
//   width: calc(100% - 40px);
//   margin: 0 auto;
// `;

export const ChartSection = styled.div`
  padding-top: 51px !important;
  position: relative;
`;
